import { useState } from "react";
import moment from "moment";
import { getDateParts } from "../../../helpers/index";
import { birthKeys } from "../../../components/BasicInfo";

export const personalDetailsConstraints = {
  firstName: {
    presence: {
      allowEmpty: false,
      message: "^Please enter your first name.",
    },
  },
  lastName: {
    presence: {
      allowEmpty: false,
      message: "^Please enter your last name.",
    },
  },
  birthDay: {
    presence: { allowEmpty: false },
  },
  birthMonth: {
    presence: { allowEmpty: false },
  },
  birthYear: {
    presence: { allowEmpty: false },
    isDateBefore: {
      date: moment().subtract({ years: 16 }),
      roundUpDay: true,
      keys: birthKeys,
    },
  },
  mobileTelephone: {
    presence: { allowEmpty: false },
    isValidTelephone: true,
  },
  addressLine1: {
    presence: {
      allowEmpty: false,
      message: "^Please enter your address line 1.",
    },
  },
  town: {
    presence: { allowEmpty: false, message: "^Please enter your town." },
  },
  postcode: {
    presence: { allowEmpty: false, message: "^Please enter your postcode." },
  },
  county: {
    presence: { allowEmpty: false, message: "^Please enter your county." },
  },
};

const transformAddressResultFields = (result, postcode) => ({
  addressLine1: result.line_1,
  addressLine2: result.line_2,
  addressLine3: result.line_3,
  town: result.town_or_city,
  county: result.county,
  country: "UK",
  postcode,
});

export const usePersonalDetailsState = (
  appData,
  matchedAddressList,
  resetAddressList
) => {
  const { birthDay, birthMonth, birthYear } = getDateParts(
    appData.dateOfBirth,
    birthKeys
  );
  const initialState = {
    birthDay,
    birthMonth,
    birthYear,
    branchCode: appData?.responsibleTeam || "",
    firstName: appData?.firstName || "",
    lastName: appData?.lastName || "",
    mobileTelephone: appData?.mobileTelephone || "",
    addressLine1: appData?.address?.addressLine1 || "",
    addressLine2: appData?.address?.addressLine2 || "",
    addressLine3: appData?.address?.addressLine3 || "",
    town: appData?.address?.town || "",
    county: appData?.address?.county || "",
    postcode: appData?.address?.postcode || "",
    country: "UK",
    isManualAddress: false,
    selectedAddressIndex: -1,
    isFindingAddress: false,
  };

  const [personalDetailsState, setPersonalDetailsState] =
    useState(initialState);
  const [errors, setErrors] = useState({});

  const handlers = {
    onChange: (key, val) => {
      if (val !== "") {
        setErrors({
          ...errors,
          [key]: [],
        });
      }
      if (key === "postcode") {
        resetAddressList([]);
        setPersonalDetailsState((prevState) => ({
          ...prevState,
          isFindingAddress: false,
        }));
      }
      setPersonalDetailsState((prevState) => ({
        ...prevState,
        [key]: val,
      }));
    },
    onAddressSelect: (selectedAddressIndex) => {
      const selectedAddress = transformAddressResultFields(
        matchedAddressList[selectedAddressIndex],
        personalDetailsState.postcode
      );
      setPersonalDetailsState((prevState) => ({
        ...prevState,
        ...selectedAddress,
        selectedAddressIndex,
      }));
    },
    manualAddress: (val) =>
      setPersonalDetailsState((prevState) => ({
        ...prevState,
        isManualAddress: val,
      })),
    findAddress: (val) =>
      setPersonalDetailsState((prevState) => ({
        ...prevState,
        isFindingAddress: val,
      })),
    resetAddressIndex: () =>
      setPersonalDetailsState((prevState) => ({
        ...prevState,
        selectedAddressIndex: -1,
      })),
  };

  return [personalDetailsState, handlers, errors, setErrors];
};
